import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, Redirect, useHistory } from "react-router-dom";
import { UserConsumer } from "../../../UserContext";
import paginationFactory, {
	PaginationProvider,
} from "react-bootstrap-table2-paginator";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { Table } from "../../../components/CustomPaginations";
import {
	statusColor,
	tableStyle,
	TrimString,
} from "../../../components/TableStyle";
import { AlertPopups } from "../../../components/AlertPopups";
import { ItemRequisitionAPI } from "./ItemRequisitionAPI";
import Header from "../../../components/Header";
import FilterationBar from "./FilterationBar";
import "./ReviewItemRequisitonStyle.scss";
import CustomeSearchBar from "../../../components/CustomeSearchBar";
import moment from "moment";
import {
	GlobalPaginationSize,
	getPaginationSizeOnRole,
} from "../../../components/GlobalPaginationSize";
import { Routes } from "../../../configurations/config";
import { APIDateFormat } from "../../Dashboard/DashboardVariables";

function ReviewItemRequsition() {
	let token,
		empDesignation = null;
	let history = useHistory();

	const defaultSorted = [
		{
			dataField: "token",
			order: "desc",
		},
	];
	const itemReqDepartmentIds = ["3", "5", "9"]; // To which review Item Requisition should be shown// SSN,accounts,admin
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [searchInput, setSearchInput] = useState(null);
	const [pagerData, setPagerData] = useState(null);
	const [statusList, setStatusList] = useState(null);
	const [selectedStatus, setSelectedStatus] = useState(null);
	const [isLoading, setIsLoading] = useState(true);
	const [apiHeaderToken, setApiHeaderToken] = useState(null);
	const [endDatePickerDisabled, setEndDatePickerDisabled] = useState(true);
	const [numberOfItemsPerPage, setNumberOfItemsPerPage] = useState(
		GlobalPaginationSize.defaultPaginationSize
	);
	const [itemRequisitionData, setItemRequisitionData] = useState([]);
	const [pageNum, setPageNum] = useState(1);
	const [sortBy, setSortBy] = useState(defaultSorted[0]);

	const getColumns = [
		{
			dataField: "token",
			text: "Token",
			sort: true,
		},
		{
			dataField: "item",
			text: "Item Name",
			sort: true,
			formatter: TrimString,
		},
		{
			dataField: "requestedBy",
			text: "Requested By",
			sort: true,
		},
		{
			dataField: "status",
			text: "Status",
			sort: true,
			headerStyle: {
				width: "20%",
			},
			style: statusColor,
		},
		{
			dataField: "action",
			text: "Action",

			formatter: (cell, row) => {
				return (
					<div>
						<Link
							to={{
								pathname: `${Routes.ReviewItemRequisitionDetail}/${row.token}`,
								state: { itemStatus: row.status },
							}}
						>
							<button className="btnStyle" title="View Detail">
								<FontAwesomeIcon
									id="edit"
									className="hoverEffect"
									icon={faEye}
									size="1x"
								/>
							</button>
						</Link>
					</div>
				);
			},
		},
	];
	useEffect(() => {
		const pageSize = getPaginationSizeOnRole(empDesignation);
		setNumberOfItemsPerPage(pageSize);

		var tokenHeader = {
			Authorization: `Bearer ${token}`,
		};
		setApiHeaderToken(tokenHeader);

		//For supervisor //get status
		axios
			.get(`${ItemRequisitionAPI.GetItemRequisitionStatusTypes}`, {
				headers: tokenHeader,
			})
			.then(({ status, data }) => {
				if (status === 200) {
					if (sessionStorage.getItem("ReviewItemRequsition"))
						if (
							JSON.parse(
								sessionStorage.getItem("ReviewItemRequsition")
							)[0]
						) {
							setSelectedStatus(
								JSON.parse(
									sessionStorage.getItem(
										"ReviewItemRequsition"
									)
								)[0]
							);
						} else
							setSelectedStatus(
								data.types.find(
									({ label }) => label === "Pending"
								)
							);
					else
						setSelectedStatus(
							data.types.find(({ label }) => label === "Pending")
						);

					let statusList = data.types.filter(
						(item) => item.label != "All"
					);
					let sorted = statusList.sort((a, b) =>
						a.label.localeCompare(b.label)
					);
					sorted.unshift({ value: 0, label: "All" });
					setStatusList(sorted);
				}
			});
		if (sessionStorage.getItem("ReviewItemRequsition"))
			if (JSON.parse(sessionStorage.getItem("ReviewItemRequsition"))[1]) {
				setStartDate(
					new Date(
						JSON.parse(
							sessionStorage.getItem("ReviewItemRequsition")
						)[1]
					)
				);
			} else setStartDate(moment(new Date()).subtract(60, "days")._d);
		else setStartDate(moment(new Date()).subtract(60, "days")._d);

		if (sessionStorage.getItem("ReviewItemRequsition"))
			if (JSON.parse(sessionStorage.getItem("ReviewItemRequsition"))[2]) {
				setEndDate(
					new Date(
						JSON.parse(
							sessionStorage.getItem("ReviewItemRequsition")
						)[2]
					)
				);
			} else setEndDate(moment(new Date())._d);
		else setEndDate(moment(new Date())._d);

		// GetDefaultItemRequisitionRequests
		axios
			.get(
				`${
					ItemRequisitionAPI.GetDefaultItemRequisitionRequests
				}?Status=${
					sessionStorage.getItem("ReviewItemRequsition")
						? JSON.parse(
								sessionStorage.getItem("ReviewItemRequsition")
						  )[0]
							? JSON.parse(
									sessionStorage.getItem(
										"ReviewItemRequsition"
									)
							  )[0].value
							: 3
						: 3
				}&PageSize=${numberOfItemsPerPage}&StartDate=${
					sessionStorage.getItem("ReviewItemRequsition")
						? JSON.parse(
								sessionStorage.getItem("ReviewItemRequsition")
						  )[1]
							? moment(
									JSON.parse(
										sessionStorage.getItem(
											"ReviewItemRequsition"
										)
									)[1]
							  ).format("YYYY-MM-DD")
							: moment(new Date())
									.subtract(60, "days")
									.format("YYYY-MM-DD")
						: moment(new Date())
								.subtract(60, "days")
								.format("YYYY-MM-DD")
				}&EndDate=${
					sessionStorage.getItem("ReviewItemRequsition")
						? JSON.parse(
								sessionStorage.getItem("ReviewItemRequsition")
						  )[2]
							? moment(
									JSON.parse(
										sessionStorage.getItem(
											"ReviewItemRequsition"
										)
									)[2]
							  ).format("YYYY-MM-DD")
							: moment(new Date()).format("YYYY-MM-DD")
						: moment(new Date()).format("YYYY-MM-DD")
				}&SortBy=${sortBy.dataField}_${sortBy.order}`,
				{
					headers: tokenHeader,
				}
			)
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setItemRequisitionData(res.data.requests);
				}
			});
	}, []);

	const filterOnStatusChange = (status) => {
		setIsLoading(true);
		let apiURL = "";
		if (searchInput === "" || searchInput === null) {
			if (startDate) {
				var startDateFormated = moment(startDate).format(APIDateFormat);
				var endDateFormated = moment(endDate).format(APIDateFormat);
				apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?Status=${status}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}&StartDate=${startDateFormated}&EndDate=${endDateFormated}`;
			} else {
				apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?Status=${status}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}`;
			}
		} else {
			if (startDate) {
				var startDateFormated = moment(startDate).format(APIDateFormat);
				var endDateFormated = moment(endDate).format(APIDateFormat);
				apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?Status=${status}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}&StartDate=${startDateFormated}&EndDate=${endDateFormated}&SearchTerm=${searchInput}`;
			} else {
				apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?Status=${status}&PageSize=${numberOfItemsPerPage}&SortBy=${sortBy.dataField}_${sortBy.order}&SearchTerm=${searchInput}`;
			}
		}
		axios
			.get(apiURL, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setItemRequisitionData(res.data.requests);
				}
			});
	};
	const filterOnDateChange = (StartDate, EndDate) => {
		setIsLoading(true);
		var startDateFormated = moment(StartDate).format(APIDateFormat);
		var endDateFormated = moment(EndDate).format(APIDateFormat);
		let apiURL = "";

		if (searchInput === "" || searchInput === null)
			apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?StartDate=${startDateFormated}&EndDate=${endDateFormated}&PageSize=${numberOfItemsPerPage}&Status=${selectedStatus.value}`;
		else
			apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?StartDate=${startDateFormated}&EndDate=${endDateFormated}&PageSize=${numberOfItemsPerPage}&Status=${selectedStatus.value}&SearchTerm=${searchInput}`;
		axios
			.get(apiURL, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setItemRequisitionData(res.data.requests);
				}
			})
			.catch((err) => {
				if (err.response) {
					AlertPopups.ErrorAlert.fire({
						text: `Item Requisition ${err.response.data.message}`,
					});
				}
			});
	};

	const receiveData = (PageSize) => {
		setIsLoading(true);
		let apiURL = "";
		if (searchInput === "" || searchInput === null) {
			if (startDate) {
				var startDateFormated = moment(startDate).format(APIDateFormat);
				var endDateFormated = moment(endDate).format(APIDateFormat);
				apiURL = `${
					ItemRequisitionAPI.GetDefaultItemRequisitionRequests
				}?PageNumber=${1}&PageSize=${PageSize}&Status=${
					selectedStatus.value
				}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}&StartDate=${startDateFormated}&EndDate=${endDateFormated}`;
			} else
				apiURL = `${
					ItemRequisitionAPI.GetDefaultItemRequisitionRequests
				}?PageNumber=${1}&PageSize=${PageSize}&Status=${
					selectedStatus.value
				}&SortBy=${sortBy.dataField}_${sortBy.order}`;
		} else {
			if (startDate) {
				var startDateFormated = moment(startDate).format(APIDateFormat);
				var endDateFormated = moment(endDate).format(APIDateFormat);
				apiURL = `${
					ItemRequisitionAPI.GetDefaultItemRequisitionRequests
				}?PageNumber=${1}&PageSize=${PageSize}&Status=${
					selectedStatus.value
				}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}&StartDate=${startDateFormated}&EndDate=${endDateFormated}&SearchTerm=${searchInput}`;
			} else
				apiURL = `${
					ItemRequisitionAPI.GetDefaultItemRequisitionRequests
				}?PageNumber=${1}&PageSize=${PageSize}&Status=${
					selectedStatus.value
				}&SortBy=${sortBy.dataField}_${
					sortBy.order
				}&SearchTerm=${searchInput}`;
		}
		axios
			.get(apiURL, {
				headers: apiHeaderToken,
			})
			.then((res) => {
				if (res.status === 200) {
					setIsLoading(false);
					setPageNum(1);
					setNumberOfItemsPerPage(PageSize);
					setPagerData(JSON.parse(res.headers["x-pagination"]));
					setItemRequisitionData(res.data.requests);
				}
			});
	};
	const handleTableChange = (type, { page, sortOrder, sortField }) => {
		setIsLoading(true);
		let getData = false;
		let apiURL = "";

		if (searchInput === "" || searchInput === null) {
			if (startDate) {
				var startDateFormated = moment(startDate).format(APIDateFormat);
				var endDateFormated = moment(endDate).format(APIDateFormat);
				if (type === "sort") {
					apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${selectedStatus.value}&SortBy=${sortField}_${sortOrder}&StartDate=${startDateFormated}&EndDate=${endDateFormated}`;
					setSortBy({ dataField: sortField, order: sortOrder });
					getData = true;
				} else if (type === "pagination") {
					apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${selectedStatus.value}&SortBy=${sortBy.dataField}_${sortBy.order}`;
					getData = true;
				}
			} else {
				if (type === "sort") {
					apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${selectedStatus.value}&SortBy=${sortField}_${sortOrder}`;
					setSortBy({ dataField: sortField, order: sortOrder });
					getData = true;
				} else if (type === "pagination") {
					apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${selectedStatus.value}&SortBy=${sortBy.dataField}_${sortBy.order}`;
					getData = true;
				}
			}
		} else {
			if (startDate) {
				var startDateFormated = moment(startDate).format(APIDateFormat);
				var endDateFormated = moment(endDate).format(APIDateFormat);
				if (type === "sort") {
					apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${selectedStatus.value}&SortBy=${sortField}_${sortOrder}&StartDate=${startDateFormated}&EndDate=${endDateFormated}&SearchTerm=${searchInput}`;
					setSortBy({ dataField: sortField, order: sortOrder });
					getData = true;
				} else if (type === "pagination") {
					apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${selectedStatus.value}&SortBy=${sortBy.dataField}_${sortBy.order}&SearchTerm=${searchInput}`;
					getData = true;
				}
			} else {
				if (type === "sort") {
					apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${selectedStatus.value}&SortBy=${sortField}_${sortOrder}&SearchTerm=${searchInput}`;
					setSortBy({ dataField: sortField, order: sortOrder });
					getData = true;
				} else if (type === "pagination") {
					apiURL = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?PageSize=${numberOfItemsPerPage}&PageNumber=${page}&Status=${selectedStatus.value}&SortBy=${sortBy.dataField}_${sortBy.order}&SearchTerm=${searchInput}`;
					getData = true;
				}
			}
		}

		if (getData) {
			axios
				.get(apiURL, {
					headers: apiHeaderToken,
				})
				.then((res) => {
					if (res.status === 200) {
						setIsLoading(false);
						setPageNum(page);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setItemRequisitionData(res.data.requests);
					}
				});
		}
	};
	const handleSearch = (event) => {
		setIsLoading(true);
		const value = event.target.value;
		setSearchInput(value);

		let apiUrl = null;
		var startDateFormated = "";
		var endDateFormated = "";

		if (value === "") {
			if (startDate) {
				startDateFormated = moment(startDate).format(APIDateFormat);
				endDateFormated = moment(endDate).format(APIDateFormat);

				axios
					.get(
						`${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?PageSize=${numberOfItemsPerPage}&Status=${selectedStatus.value}&StartDate=${startDateFormated}&EndDate=${endDateFormated}&SortBy=${sortBy.dataField}_${sortBy.order}`,
						{
							headers: apiHeaderToken,
						}
					)
					.then((res) => {
						if (res.status === 200) {
							setPageNum(1);
							setIsLoading(false);
							setPagerData(
								JSON.parse(res.headers["x-pagination"])
							);
							setItemRequisitionData(res.data.requests);
						}
					});
			}
		} else {
			if (startDate) {
				startDateFormated = moment(startDate).format(APIDateFormat);
				endDateFormated = moment(endDate).format(APIDateFormat);
				apiUrl = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?PageSize=${numberOfItemsPerPage}&Status=${selectedStatus.value}&StartDate=${startDateFormated}&EndDate=${endDateFormated}&SortBy=${sortBy.dataField}_${sortBy.order}&SearchTerm=${value}`;
			} else {
				apiUrl = `${ItemRequisitionAPI.GetDefaultItemRequisitionRequests}?PageSize=${numberOfItemsPerPage}&Status=${selectedStatus.value}&SortBy=${sortBy.dataField}_${sortBy.order}&SearchTerm=${value}`;
			}

			axios
				.get(apiUrl, {
					headers: apiHeaderToken,
				})
				.then((res) => {
					if (res.status === 200) {
						setPageNum(1);
						setIsLoading(false);
						setPagerData(JSON.parse(res.headers["x-pagination"]));
						setItemRequisitionData(res.data.requests);
					}
				});
		}
	};
	const storeFiltersStates = (value, property) => {
		let obj = [];
		if (sessionStorage.getItem("ReviewItemRequsition"))
			obj = JSON.parse(sessionStorage.getItem("ReviewItemRequsition"));
		if (property === "status") obj[0] = value;
		else if (property === "startDate") obj[1] = value;
		else if (property === "endDate") obj[2] = value;
		sessionStorage.setItem("ReviewItemRequsition", JSON.stringify(obj));
	};
	const rowEvents = {
		onClick: (e, row) => {
			history.push({
				pathname: `${Routes.ReviewItemRequisitionDetail}/${row.token}`,
				state: { itemStatus: row.status },
			});
		},
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				empDesignation = userDetails.designation;
				return itemReqDepartmentIds.includes(
					userDetails.department.toString()
				) ||
					userDetails.empRole.includes("2") ||
					userDetails.designation.toString() === "4" ||
					userDetails.designation.toString() === "5" ? (
					<>
						<div className="container-fluid pl-3 pr-3">
							<Header
								title="Review Item Requisition Requests"
								headerBorder="false"
							/>
							<FilterationBar
								status={statusList}
								selectedStatus={selectedStatus}
								onStatusChange={(value) => {
									setSelectedStatus(value);
									filterOnStatusChange(value.value);
									storeFiltersStates(value, "status");
								}}
								startDate={startDate}
								endDate={endDate}
								endDatePickerDisabled={endDatePickerDisabled}
								onStartDateChange={(startDate) => {
									setStartDate(startDate);
									storeFiltersStates(startDate, "startDate");
									//if user select start date again after selecting end date(when end date is enabled)
									if (endDate) {
										filterOnDateChange(startDate, endDate);
									} else {
										setEndDatePickerDisabled(false);
									}
								}}
								onEndDateChange={(endDate) => {
									setEndDate(endDate);
									storeFiltersStates(endDate, "endDate");
									filterOnDateChange(startDate, endDate);
								}}
							/>
							<CustomeSearchBar
								handleSearch={(event) => handleSearch(event)}
								tooltip={
									"Search by code,name,designation,login info and status"
								}
							/>
							<PaginationProvider
								pagination={paginationFactory({
									custom: true,
									totalSize: pagerData
										? pagerData.TotalCount
										: 0,
									page: pageNum,
									sizePerPage: numberOfItemsPerPage,
									paginationSize: numberOfItemsPerPage,
								})}
							>
								{({
									paginationProps,
									paginationTableProps,
								}) => {
									return (
										<Table
											inputValue={searchInput}
											keyField={"token"}
											columns={getColumns}
											items={itemRequisitionData}
											tableStyle={tableStyle}
											paginationProps={paginationProps}
											paginationTableProps={
												paginationTableProps
											}
											onTablePageChange={
												handleTableChange
											}
											defaultSorted={defaultSorted}
											showFeedback={false}
											tableLoader={isLoading}
											SearchBar={() => {
												return null;
											}}
											pagerData={pagerData}
											receiveData={(PageSize) => {
												receiveData(PageSize);
											}}
											rowEvents={rowEvents}
										/>
									);
								}}
							</PaginationProvider>
						</div>
					</>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}

export default ReviewItemRequsition;
